import { fromJS } from 'immutable'
import {
  PUBLIC_HOLIDAY_CREATE_REQUEST,
  PUBLIC_HOLIDAY_CREATE_SUCCESS,
  PUBLIC_HOLIDAY_CREATE_FAILURE,
  PUBLIC_HOLIDAY_CREATE_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case PUBLIC_HOLIDAY_CREATE_REQUEST:
      return state
        .set('isFetching', true)
    case PUBLIC_HOLIDAY_CREATE_SUCCESS:
      return state
        .set('createdHoliday', fromJS(action.payload.createdHoliday))
        .set('status', 200)
        .set('message', 'Created Successfully.')
        .set('isFetching', false)
    case PUBLIC_HOLIDAY_CREATE_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('createdHoliday', fromJS(action.payload.message))
        .set('status', 'Error')
        .set('message', fromJS(action.payload.response.message))
        .set('isFetching', false)
    case PUBLIC_HOLIDAY_CREATE_RESET:
      return state
        .delete('createdHoliday')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/public-holiday/public-holiday-create-reducer.js